'use client';
import React from 'react';
import '@mantine/hooks';
import { useMantineStyleNonce } from '../MantineProvider/Mantine.context.mjs';
import '../MantineProvider/default-theme.mjs';
import '../MantineProvider/MantineProvider.mjs';
import '../MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs';
import { stylesToString } from './styles-to-string/styles-to-string.mjs';

function InlineStyles({ selector, styles, media }) {
  const nonce = useMantineStyleNonce();
  return /* @__PURE__ */ React.createElement(
    "style",
    {
      "data-mantine-styles": "inline",
      nonce: nonce?.(),
      dangerouslySetInnerHTML: { __html: stylesToString({ selector, styles, media }) }
    }
  );
}

export { InlineStyles };
//# sourceMappingURL=InlineStyles.mjs.map
